import React from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardEmbed } from '../../components/DashboardEmbed';
import { getDashboardUrlByRole, getDashboardTitle, getDashboardDescription } from '../../config/dashboards';

export const RHDashboard = ({ user }: { user: any }) => {
  const { t } = useTranslation();
  const role = user?.role;
  return (
    <div className="p-4 md:p-6">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-white mb-1">{t('dashboard.hr')}</h1>
        <p className="text-gray-400 text-sm">Gestion du personnel et analyse des effectifs</p>
      </div>
      <DashboardEmbed title={getDashboardTitle('hr')} embedUrl={getDashboardUrlByRole(role,'hr')} description={getDashboardDescription('hr')} userRole={role}/>
    </div>
  );
};
